var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5574 3.67589C29.2155 6.24199 29.2155 11.5988 29.2155 11.5988C29.2155 11.5988 29.2155 16.9557 28.5574 19.5218C28.1917 20.9402 27.1217 22.0562 25.7667 22.4335C23.3057 23.119 14.8154 23.119 14.8154 23.119C14.8154 23.119 6.32936 23.119 3.86406 22.4335C2.50324 22.0505 1.43475 20.9359 1.07331 19.5218C0.415222 16.9557 0.415222 11.5988 0.415222 11.5988C0.415222 11.5988 0.415222 6.24199 1.07331 3.67589C1.43907 2.25748 2.509 1.14147 3.86406 0.764182C6.32936 0.0787351 14.8154 0.0787354 14.8154 0.0787354C14.8154 0.0787354 23.3057 0.0787351 25.7667 0.764182C27.1275 1.14723 28.196 2.2618 28.5574 3.67589ZM11.9353 16.6389L20.5754 11.5988L11.9353 6.5588V16.6389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.60eebcee4c67f28c2813319d9562d0cd.svg";
export { ForwardRef as ReactComponent };